module.exports = __webpack_public_path__ + "static/media/Unique.9ff4cf64.ttf";